import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { scopes, msalInstance, dataMigrationBaseUrl, dcsbaseurl, orionbaseurl } from "../../authConfig";
import { baseurl } from "../../authConfig";

const instance = axios.create({
  baseURL: baseurl,
});

const dataMigrationInstance = axios.create({
  baseURL: dataMigrationBaseUrl,
});

const dcsInstance = axios.create({
  baseURL: dcsbaseurl,
});

const orionInstance = axios.create({
  baseURL: orionbaseurl,
});

const attachAuthInterceptor = (axiosInstance: typeof instance) => {
  axiosInstance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      if (config.headers) {
        // config.headers["Content-Type"] = "application/json";
      }
      const account = msalInstance.getAllAccounts()[0];
      if (account) {
        const accessTokenResponse = await msalInstance.acquireTokenSilent({
          scopes: scopes,
          account: account,
        });

        if (accessTokenResponse) {
          const accessToken = accessTokenResponse.accessToken;
          if (config.headers && accessToken) {
            config.headers["Authorization"] = "Bearer " + accessToken;
          }
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

attachAuthInterceptor(instance);
attachAuthInterceptor(dataMigrationInstance);
attachAuthInterceptor(dcsInstance)
attachAuthInterceptor(orionInstance)

export { instance, dataMigrationInstance, dcsInstance, orionInstance };
